import {useEffect, useRef, useState} from "react";

import {useUserReelPlayerSettingsSync} from "./use_user_reel_player_settings_sync";

interface IReelPlayerProps {
    onEnded?: () => void;
}

export const useReelPlayer = (props: IReelPlayerProps) => {
    const {defaultPlayerSettings, savePlayerSettings, refreshPlayerSettings} = useUserReelPlayerSettingsSync();
    const [hasBeenPlayed, setHasBeenPlayed] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isMuted, setIsMuted] = useState(defaultPlayerSettings.muted);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        setIsMuted(defaultPlayerSettings.muted);
    }, [defaultPlayerSettings.muted]);

    useEffect(() => {
        if (videoRef.current) {
            const onVideoEnded = () => {
                props.onEnded?.();
                setIsPlaying(false);
            };

            const onVideoPause = () => {
                setIsPlaying(false);
            };

            const onVideoPlay = () => {
                setIsPlaying(true);
            };

            const onVideoWaiting = () => {
                setIsLoading(true);
            };

            const onVideoPlaying = () => {
                setHasBeenPlayed(true);
                setIsLoading(false);
            };

            const onVideoCanPlay = () => {
                setIsLoading(false);
            };

            videoRef.current.addEventListener("ended", onVideoEnded);
            videoRef.current.addEventListener("pause", onVideoPause);
            videoRef.current.addEventListener("play", onVideoPlay);
            videoRef.current.addEventListener("waiting", onVideoWaiting);
            videoRef.current.addEventListener("playing", onVideoPlaying);
            videoRef.current.addEventListener("canplay", onVideoCanPlay);

            return () => {
                if (videoRef.current) {
                    videoRef.current.removeEventListener("ended", onVideoEnded);
                    videoRef.current.removeEventListener("pause", onVideoPause);
                    videoRef.current.removeEventListener("play", onVideoPlay);
                    videoRef.current.removeEventListener("waiting", onVideoWaiting);
                    videoRef.current.removeEventListener("playing", onVideoPlaying);
                    videoRef.current.removeEventListener("canplay", onVideoCanPlay);
                }
            };
        }
    }, [videoRef.current, setIsPlaying, setHasBeenPlayed, setIsLoading, props.onEnded]);

    useEffect(() => {
        if (!videoRef.current) {
            return;
        }

        videoRef.current.muted = isMuted;

        if (isPlaying) {
            videoRef.current.play().catch(() => {
                setIsPlaying(false);
            });
        } else {
            videoRef.current.pause();
        }
    }, [videoRef.current, isPlaying, isMuted]);

    const play = () => {
        setIsPlaying(true);
        setHasBeenPlayed(true);
    };

    const pause = () => {
        setIsPlaying(false);
    };

    const togglePlay = () => {
        setIsPlaying((prevIsPlaying) => !prevIsPlaying);
    };

    const rewind = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
        }
    };

    const mute = () => {
        setIsMuted(true);
        savePlayerSettings({muted: true});
    };

    const unmute = () => {
        setIsMuted(false);
        savePlayerSettings({muted: false});
    };

    return {
        videoRef,
        isPlaying,
        isLoading,
        isMuted,
        hasBeenPlayed,
        play,
        pause,
        togglePlay,
        mute,
        unmute,
        rewind,
        refreshPlayerSettings
    };
};
import {useEffect, useRef, useState} from "react";

import {useUserReelPlayerSettingsSync} from "./use_user_reel_player_settings_sync";

interface IReelPlayerProps {
    onEnded?: () => void;
}

export const useReelPlayer = (props: IReelPlayerProps) => {
    const {defaultPlayerSettings, savePlayerSettings, refreshPlayerSettings} = useUserReelPlayerSettingsSync();
    const [hasBeenPlayed, setHasBeenPlayed] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isMuted, setIsMuted] = useState(defaultPlayerSettings.muted);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        setIsMuted(defaultPlayerSettings.muted);
    }, [defaultPlayerSettings.muted]);

    useEffect(() => {
        if (videoRef.current) {
            const onVideoEnded = () => {
                props.onEnded?.();
                setIsPlaying(false);
            };

            const onVideoPause = () => {
                setIsPlaying(false);
            };

            const onVideoPlay = () => {
                setIsPlaying(true);
            };

            const onVideoWaiting = () => {
                setIsLoading(true);
            };

            const onVideoPlaying = () => {
                setHasBeenPlayed(true);
                setIsLoading(false);
            };

            const onVideoCanPlay = () => {
                setIsLoading(false);
            };

            videoRef.current.addEventListener("ended", onVideoEnded);
            videoRef.current.addEventListener("pause", onVideoPause);
            videoRef.current.addEventListener("play", onVideoPlay);
            videoRef.current.addEventListener("waiting", onVideoWaiting);
            videoRef.current.addEventListener("playing", onVideoPlaying);
            videoRef.current.addEventListener("canplay", onVideoCanPlay);

            return () => {
                if (videoRef.current) {
                    videoRef.current.removeEventListener("ended", onVideoEnded);
                    videoRef.current.removeEventListener("pause", onVideoPause);
                    videoRef.current.removeEventListener("play", onVideoPlay);
                    videoRef.current.removeEventListener("waiting", onVideoWaiting);
                    videoRef.current.removeEventListener("playing", onVideoPlaying);
                    videoRef.current.removeEventListener("canplay", onVideoCanPlay);
                }
            };
        }
    }, [videoRef.current, setIsPlaying, setHasBeenPlayed, setIsLoading, props.onEnded]);

    useEffect(() => {
        if (!videoRef.current) {
            return;
        }

        videoRef.current.muted = isMuted;

        if (isPlaying) {
            videoRef.current.play().catch(() => {
                setIsPlaying(false);
            });
        } else {
            videoRef.current.pause();
        }
    }, [videoRef.current, isPlaying, isMuted]);

    const play = () => {
        setIsPlaying(true);
        setHasBeenPlayed(true);
    };

    const pause = () => {
        setIsPlaying(false);
    };

    const togglePlay = () => {
        setIsPlaying((prevIsPlaying) => !prevIsPlaying);
    };

    const rewind = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
        }
    };

    const mute = () => {
        setIsMuted(true);
        savePlayerSettings({muted: true});
    };

    const unmute = () => {
        setIsMuted(false);
        savePlayerSettings({muted: false});
    };

    return {
        videoRef,
        isPlaying,
        isLoading,
        isMuted,
        hasBeenPlayed,
        play,
        pause,
        togglePlay,
        mute,
        unmute,
        rewind,
        refreshPlayerSettings
    };
};
